import React, { useState, useContext, useEffect } from 'react'
import {
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  FormHelperText,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import { BrowserView, MobileView, isBrowser } from 'react-device-detect'
import { Controller, useForm, useFormContext } from 'react-hook-form'
import { SessionContextStore } from '../../../context/SessionContext'
import {
  UserProfileContextStore,
  ACTIONS,
} from '../../../context/UserProfileContext'
import { OptionalTag } from '../../Core/OptionalTag'
import { UserApi } from '../../../api/user.api'
import {
  EventEmitterService,
  EventKey,
} from '../../../services/EventEmitterService'
import '../UserProfile.css'
import { Action } from '../../../models/Action'
import StorageService from '../../../services/StorageService'
import {
  STATE_EXPIRY_TTL,
  COUNTRIES,
  AircraftLimitations,
  ExcludedUses,
} from '../../../Constants'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import { showError, awaitWithLoading } from '../../../services/utils'
import LocalizationService from '../../../services/LocalizationService'
import { ProposalSessionContextStore } from '../../../context/ProposalSessionContext'
import { useLocation } from 'react-router-dom'
import { TooltipInformationSection } from './TooltipInformationSection'

export const AdditionalAircraftsSection = (props) => {
  const location = useLocation()
  let sessionContext = useContext(SessionContextStore)
  const [singleEngineLand, setSingleEngineLand] = React.useState(true)
  const [singleEngineSeaplane, setSingleEngineSeaplane] = React.useState(
    sessionContext.user.singleEngineSeaplane
  )
  const [multiEngineLand, setMultiEngineLand] = React.useState(
    sessionContext.user.multiEngineLand
  )

  const { register, watch, trigger, setValue, errors, control, getValues } =
    useFormContext()

  useEffect(() => {
    if (sessionContext.user.userVehicles[0]) {
      setValue(
        'single_engine_seaplane',
        sessionContext.user.userVehicles[0].single_engine_seaplane
      )
      setValue(
        'multi_engine_land',
        sessionContext.user.userVehicles[0].multi_engine_land
      )
    }
  }, [sessionContext.user])

  return (
    <>
      <div className="text-small-title bold black">
        Would you like to cover additional aircraft types?
      </div>
      <div className="text-small margin-top-small gray">
        Your Non-Owned aircraft policy includes{' '}
        <span className="bold">single engine land aircraft and gliders.</span>{' '}
        Click below to add additional types.
      </div>
      <br />
      <FormControlLabel
        name="single_engine_land"
        disabled
        label={'Single engine land aircraft'}
        control={<Checkbox checked color="primary" />}
      />

      <Controller
        name="single_engine_seaplane"
        control={control}
        defaultValue={false}
        render={(props) => (
          <FormControlLabel
            label={'Single engine seaplane aircraft'}
            control={
              <Checkbox
                color="primary"
                onBlur={props.onBlur}
                onChange={(e) => {
                  props.onChange(e.target.checked)
                  setSingleEngineSeaplane(e.target.checked)
                }}
                checked={props.value}
              />
            }
          />
        )}
      />

      <Controller
        name="multi_engine_land"
        control={control}
        defaultValue={false}
        render={(props) => (
          <FormControlLabel
            label={'Multi-engine land aircraft'}
            control={
              <Checkbox
                color="primary"
                onBlur={props.onBlur}
                onChange={(e) => {
                  props.onChange(e.target.checked)
                  setMultiEngineLand(e.target.checked)
                }}
                checked={props.value}
              />
            }
          />
        )}
      />

      {sessionContext.user.insuranceType == 'Personal'
        ? singleEngineLand &&
          !singleEngineSeaplane &&
          !multiEngineLand && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['SEL_NO_CFI_B1']}
            />
          )
        : singleEngineLand &&
          !singleEngineSeaplane &&
          !multiEngineLand && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['SEL_CFI_B5']}
            />
          )}
      {sessionContext.user.insuranceType == 'Personal'
        ? singleEngineSeaplane &&
          singleEngineLand &&
          !multiEngineLand && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['SES_NO_CFI_B2']}
            />
          )
        : singleEngineSeaplane &&
          singleEngineLand &&
          !multiEngineLand && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['SES_CFI_B6']}
            />
          )}
      {sessionContext.user.insuranceType == 'Personal'
        ? multiEngineLand &&
          singleEngineLand &&
          !singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['MEL_NO_CFI_B3']}
            />
          )
        : multiEngineLand &&
          singleEngineLand &&
          !singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['MEL_CFI_B7']}
            />
          )}
      {sessionContext.user.insuranceType == 'Personal'
        ? singleEngineLand &&
          multiEngineLand &&
          singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['SES_MEL_NO_CFI_B4']}
            />
          )
        : singleEngineLand &&
          multiEngineLand &&
          singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Aircraft limitations'}
              limitationInfo={AircraftLimitations['SES_MEL_CFI_B8']}
            />
          )}

      {sessionContext.user.insuranceType == 'Personal'
        ? !singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Excluded uses'}
              limitationInfo={ExcludedUses['SEL_OR_MEL_NO_CFI_A1']}
            />
          )
        : !singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Excluded uses'}
              limitationInfo={ExcludedUses['SEL_OR_MEL_CFI_A3']}
            />
          )}
      {sessionContext.user.insuranceType == 'Personal'
        ? singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Excluded uses'}
              limitationInfo={ExcludedUses['SES_NO_CFI_A2']}
            />
          )
        : singleEngineSeaplane && (
            <TooltipInformationSection
              title={'Excluded uses'}
              limitationInfo={ExcludedUses['SES_CFI_A4']}
            />
          )}
    </>
  )
}
